import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackTopAgentImage = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'Agent block 1'
    });
};

export const trackViewAgentPropertiesLink = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: 'Agent properties link'
    });
};

export const trackEmailAgentCTA = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'email main btn'
    });
};

export const trackCallAgentCTA = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'call',
        eventLabel: 'call main btn'
    });
};

export const trackCallAgentCTADesktop = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'call',
        eventLabel: 'Agent phone number 1'
    });
};

export const trackCallAgentSplitTest = (variant: 'original' | 'variant') => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'optimizely',
        eventAction: 'lex-595-call-agent-click',
        eventLabel: variant
    });
};

export const trackCallAgentVariantReveal = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'reveal agent number'
    });
};
